import AA from "assets/icons/flags/aa.svg";
import AD from "assets/icons/flags/ad.svg";
import AE from "assets/icons/flags/ae.svg";
import AF from "assets/icons/flags/af.svg";
import AG from "assets/icons/flags/ag.svg";
import AI from "assets/icons/flags/ai.svg";
import AL from "assets/icons/flags/al.svg";
import AM from "assets/icons/flags/am.svg";
import AO from "assets/icons/flags/ao.svg";
import AQ from "assets/icons/flags/aq.svg";
import AR from "assets/icons/flags/ar.svg";
import AS from "assets/icons/flags/as.svg";
import AT from "assets/icons/flags/at.svg";
import AU from "assets/icons/flags/au.svg";
import AW from "assets/icons/flags/aw.svg";
import AX from "assets/icons/flags/ax.svg";
import AZ from "assets/icons/flags/az.svg";
import BA from "assets/icons/flags/ba.svg";
import BB from "assets/icons/flags/bb.svg";
import BD from "assets/icons/flags/bd.svg";
import BE from "assets/icons/flags/be.svg";
import BF from "assets/icons/flags/bf.svg";
import BG from "assets/icons/flags/bg.svg";
import BH from "assets/icons/flags/bh.svg";
import BI from "assets/icons/flags/bi.svg";
import BJ from "assets/icons/flags/bj.svg";
import BL from "assets/icons/flags/bl.svg";
import BM from "assets/icons/flags/bm.svg";
import BN from "assets/icons/flags/bn.svg";
import BO from "assets/icons/flags/bo.svg";
import BQ_BO from "assets/icons/flags/bq-bo.svg";
import BQ_SA from "assets/icons/flags/bq-sa.svg";
import BQ_SE from "assets/icons/flags/bq-se.svg";
import BR from "assets/icons/flags/br.svg";
import BS from "assets/icons/flags/bs.svg";
import BT from "assets/icons/flags/bt.svg";
import BV from "assets/icons/flags/bv.svg";
import BW from "assets/icons/flags/bw.svg";
import BZ from "assets/icons/flags/bz.svg";
import CA from "assets/icons/flags/ca.svg";
import CC from "assets/icons/flags/cc.svg";
import CD from "assets/icons/flags/cd.svg";
import CF from "assets/icons/flags/cf.svg";
import CG from "assets/icons/flags/cg.svg";
import CH from "assets/icons/flags/ch.svg";
import CI from "assets/icons/flags/ci.svg";
import CK from "assets/icons/flags/ck.svg";
import CL from "assets/icons/flags/cl.svg";
import CM from "assets/icons/flags/cm.svg";
import CO from "assets/icons/flags/co.svg";
import CR from "assets/icons/flags/cr.svg";
import CV from "assets/icons/flags/cv.svg";
import CW from "assets/icons/flags/cw.svg";
import CX from "assets/icons/flags/cx.svg";
import CY from "assets/icons/flags/cy.svg";
import CZ from "assets/icons/flags/cz.svg";
import DE from "assets/icons/flags/de.svg";
import DJ from "assets/icons/flags/dj.svg";
import DK from "assets/icons/flags/dk.svg";
import DM from "assets/icons/flags/dm.svg";
import DO from "assets/icons/flags/do.svg";
import DZ from "assets/icons/flags/dz.svg";
import EC from "assets/icons/flags/ec.svg";
import EE from "assets/icons/flags/ee.svg";
import EG from "assets/icons/flags/eg.svg";
import EH from "assets/icons/flags/eh.svg";
import ER from "assets/icons/flags/er.svg";
import ES from "assets/icons/flags/es.svg";
import ET from "assets/icons/flags/et.svg";
import EU from "assets/icons/flags/eu.svg";
import FI from "assets/icons/flags/fi.svg";
import FJ from "assets/icons/flags/fj.svg";
import FK from "assets/icons/flags/fk.svg";
import FM from "assets/icons/flags/fm.svg";
import FO from "assets/icons/flags/fo.svg";
import FR from "assets/icons/flags/fr.svg";
import GA from "assets/icons/flags/ga.svg";
import GD from "assets/icons/flags/gd.svg";
import GE from "assets/icons/flags/ge.svg";
import GF from "assets/icons/flags/gf.svg";
import GG from "assets/icons/flags/gg.svg";
import GH from "assets/icons/flags/gh.svg";
import GI from "assets/icons/flags/gi.svg";
import GL from "assets/icons/flags/gl.svg";
import GM from "assets/icons/flags/gm.svg";
import GN from "assets/icons/flags/gn.svg";
import GP from "assets/icons/flags/gp.svg";
import GQ from "assets/icons/flags/gq.svg";
import GR from "assets/icons/flags/gr.svg";
import GS from "assets/icons/flags/gs.svg";
import GT from "assets/icons/flags/gt.svg";
import GU from "assets/icons/flags/gu.svg";
import GW from "assets/icons/flags/gw.svg";
import GY from "assets/icons/flags/gy.svg";
import HK from "assets/icons/flags/hk.svg";
import HM from "assets/icons/flags/hm.svg";
import HN from "assets/icons/flags/hn.svg";
import HR from "assets/icons/flags/hr.svg";
import HT from "assets/icons/flags/ht.svg";
import HU from "assets/icons/flags/hu.svg";
import ID from "assets/icons/flags/id.svg";
import IE from "assets/icons/flags/ie.svg";
import IL from "assets/icons/flags/il.svg";
import IM from "assets/icons/flags/im.svg";
import IN from "assets/icons/flags/in.svg";
import IO from "assets/icons/flags/io.svg";
import IQ from "assets/icons/flags/iq.svg";
import IS from "assets/icons/flags/is.svg";
import IT from "assets/icons/flags/it.svg";
import JE from "assets/icons/flags/je.svg";
import JM from "assets/icons/flags/jm.svg";
import JO from "assets/icons/flags/jo.svg";
import JP from "assets/icons/flags/jp.svg";
import KE from "assets/icons/flags/ke.svg";
import KG from "assets/icons/flags/kg.svg";
import KH from "assets/icons/flags/kh.svg";
import KI from "assets/icons/flags/ki.svg";
import KM from "assets/icons/flags/km.svg";
import KN from "assets/icons/flags/kn.svg";
import KR from "assets/icons/flags/kr.svg";
import KW from "assets/icons/flags/kw.svg";
import KY from "assets/icons/flags/ky.svg";
import KZ from "assets/icons/flags/kz.svg";
import LA from "assets/icons/flags/la.svg";
import LB from "assets/icons/flags/lb.svg";
import LC from "assets/icons/flags/lc.svg";
import LI from "assets/icons/flags/li.svg";
import LK from "assets/icons/flags/lk.svg";
import LR from "assets/icons/flags/lr.svg";
import LS from "assets/icons/flags/ls.svg";
import LT from "assets/icons/flags/lt.svg";
import LU from "assets/icons/flags/lu.svg";
import LV from "assets/icons/flags/lv.svg";
import LY from "assets/icons/flags/ly.svg";
import MA from "assets/icons/flags/ma.svg";
import MC from "assets/icons/flags/mc.svg";
import MD from "assets/icons/flags/md.svg";
import ME from "assets/icons/flags/me.svg";
import MF from "assets/icons/flags/mf.svg";
import MG from "assets/icons/flags/mg.svg";
import MH from "assets/icons/flags/mh.svg";
import MK from "assets/icons/flags/mk.svg";
import ML from "assets/icons/flags/ml.svg";
import MM from "assets/icons/flags/mm.svg";
import MN from "assets/icons/flags/mn.svg";
import MO from "assets/icons/flags/mo.svg";
import MP from "assets/icons/flags/mp.svg";
import MQ from "assets/icons/flags/mq.svg";
import MR from "assets/icons/flags/mr.svg";
import MS from "assets/icons/flags/ms.svg";
import MT from "assets/icons/flags/mt.svg";
import MU from "assets/icons/flags/mu.svg";
import MV from "assets/icons/flags/mv.svg";
import MW from "assets/icons/flags/mw.svg";
import MX from "assets/icons/flags/mx.svg";
import MY from "assets/icons/flags/my.svg";
import MZ from "assets/icons/flags/mz.svg";
import NA from "assets/icons/flags/na.svg";
import NC from "assets/icons/flags/nc.svg";
import NE from "assets/icons/flags/ne.svg";
import NF from "assets/icons/flags/nf.svg";
import NG from "assets/icons/flags/ng.svg";
import NI from "assets/icons/flags/ni.svg";
import NL from "assets/icons/flags/nl.svg";
import NO from "assets/icons/flags/no.svg";
import NP from "assets/icons/flags/np.svg";
import NR from "assets/icons/flags/nr.svg";
import NU from "assets/icons/flags/nu.svg";
import NZ from "assets/icons/flags/nz.svg";
import OM from "assets/icons/flags/om.svg";
import PA from "assets/icons/flags/pa.svg";
import PE from "assets/icons/flags/pe.svg";
import PF from "assets/icons/flags/pf.svg";
import PG from "assets/icons/flags/pg.svg";
import PH from "assets/icons/flags/ph.svg";
import PK from "assets/icons/flags/pk.svg";
import PL from "assets/icons/flags/pl.svg";
import PM from "assets/icons/flags/pm.svg";
import PN from "assets/icons/flags/pn.svg";
import PR from "assets/icons/flags/pr.svg";
import PS from "assets/icons/flags/ps.svg";
import PT from "assets/icons/flags/pt.svg";
import PW from "assets/icons/flags/pw.svg";
import PY from "assets/icons/flags/py.svg";
import QA from "assets/icons/flags/qa.svg";
import RE from "assets/icons/flags/re.svg";
import RO from "assets/icons/flags/ro.svg";
import RS from "assets/icons/flags/rs.svg";
import RW from "assets/icons/flags/rw.svg";
import SA from "assets/icons/flags/sa.svg";
import SB from "assets/icons/flags/sb.svg";
import SC from "assets/icons/flags/sc.svg";
import SD from "assets/icons/flags/sd.svg";
import SE from "assets/icons/flags/se.svg";
import SG from "assets/icons/flags/sg.svg";
import SH from "assets/icons/flags/sh.svg";
import SI from "assets/icons/flags/si.svg";
import SJ from "assets/icons/flags/sj.svg";
import SK from "assets/icons/flags/sk.svg";
import SL from "assets/icons/flags/sl.svg";
import SM from "assets/icons/flags/sm.svg";
import SN from "assets/icons/flags/sn.svg";
import SO from "assets/icons/flags/so.svg";
import SR from "assets/icons/flags/sr.svg";
import SS from "assets/icons/flags/ss.svg";
import ST from "assets/icons/flags/st.svg";
import SV from "assets/icons/flags/sv.svg";
import SX from "assets/icons/flags/sx.svg";
import SZ from "assets/icons/flags/sz.svg";
import TC from "assets/icons/flags/tc.svg";
import TD from "assets/icons/flags/td.svg";
import TF from "assets/icons/flags/tf.svg";
import TG from "assets/icons/flags/tg.svg";
import TH from "assets/icons/flags/th.svg";
import TJ from "assets/icons/flags/tj.svg";
import TK from "assets/icons/flags/tk.svg";
import TL from "assets/icons/flags/tl.svg";
import TM from "assets/icons/flags/tm.svg";
import TN from "assets/icons/flags/tn.svg";
import TO from "assets/icons/flags/to.svg";
import TR from "assets/icons/flags/tr.svg";
import TT from "assets/icons/flags/tt.svg";
import TV from "assets/icons/flags/tv.svg";
import TW from "assets/icons/flags/tw.svg";
import TZ from "assets/icons/flags/tz.svg";
import UA from "assets/icons/flags/ua.svg";
import UG from "assets/icons/flags/ug.svg";
import UK from "assets/icons/flags/uk.svg";
import UM from "assets/icons/flags/um.svg";
import US from "assets/icons/flags/us.svg";
import UY from "assets/icons/flags/uy.svg";
import UZ from "assets/icons/flags/uz.svg";
import VA from "assets/icons/flags/va.svg";
import VC from "assets/icons/flags/vc.svg";
import VG from "assets/icons/flags/vg.svg";
import VI from "assets/icons/flags/vi.svg";
import VN from "assets/icons/flags/vn.svg";
import VU from "assets/icons/flags/vu.svg";
import WF from "assets/icons/flags/wf.svg";
import WS from "assets/icons/flags/ws.svg";
import XK from "assets/icons/flags/xk.svg";
import YE from "assets/icons/flags/ye.svg";
import YT from "assets/icons/flags/yt.svg";
import ZA from "assets/icons/flags/za.svg";
import ZM from "assets/icons/flags/zm.svg";
import ZW from "assets/icons/flags/zw.svg";

type TCountryData = {
  name: string;
  flag: string;
};

export type TCountryCode =
  | "AA"
  | "AD"
  | "AE"
  | "AF"
  | "AG"
  | "AI"
  | "AL"
  | "AM"
  | "AO"
  | "AQ"
  | "AR"
  | "AS"
  | "AT"
  | "AU"
  | "AW"
  | "AX"
  | "AZ"
  | "BA"
  | "BB"
  | "BD"
  | "BQ_BO"
  | "BQ_SA"
  | "BQ_SE"
  | "BE"
  | "BF"
  | "BG"
  | "BH"
  | "BI"
  | "BJ"
  | "BL"
  | "BM"
  | "BN"
  | "BO"
  | "BR"
  | "BS"
  | "BT"
  | "BV"
  | "BW"
  | "BZ"
  | "CA"
  | "CC"
  | "CD"
  | "CF"
  | "CG"
  | "CH"
  | "CI"
  | "CK"
  | "CL"
  | "CM"
  | "CO"
  | "CR"
  | "CV"
  | "CW"
  | "CX"
  | "CY"
  | "CZ"
  | "DE"
  | "DJ"
  | "DK"
  | "DM"
  | "DO"
  | "DZ"
  | "EC"
  | "EE"
  | "EG"
  | "EH"
  | "ER"
  | "ES"
  | "ET"
  | "EU"
  | "FI"
  | "FJ"
  | "FK"
  | "FM"
  | "FO"
  | "FR"
  | "GA"
  | "GB"
  | "GD"
  | "GE"
  | "GF"
  | "GG"
  | "GH"
  | "GI"
  | "GL"
  | "GM"
  | "GN"
  | "GP"
  | "GQ"
  | "GR"
  | "GS"
  | "GT"
  | "GU"
  | "GW"
  | "GY"
  | "HK"
  | "HM"
  | "HN"
  | "HR"
  | "HT"
  | "HU"
  | "ID"
  | "IE"
  | "IL"
  | "IM"
  | "IN"
  | "IO"
  | "IQ"
  | "IS"
  | "IT"
  | "JE"
  | "JM"
  | "JO"
  | "JP"
  | "KE"
  | "KG"
  | "KH"
  | "KI"
  | "KM"
  | "KN"
  | "KR"
  | "KW"
  | "KY"
  | "KZ"
  | "LA"
  | "LB"
  | "LC"
  | "LI"
  | "LK"
  | "LR"
  | "LS"
  | "LT"
  | "LU"
  | "LV"
  | "LY"
  | "MA"
  | "MC"
  | "MD"
  | "ME"
  | "MF"
  | "MG"
  | "MH"
  | "MK"
  | "ML"
  | "MM"
  | "MN"
  | "MO"
  | "MP"
  | "MQ"
  | "MR"
  | "MS"
  | "MT"
  | "MU"
  | "MV"
  | "MW"
  | "MX"
  | "MY"
  | "MZ"
  | "NA"
  | "NC"
  | "NE"
  | "NF"
  | "NG"
  | "NI"
  | "NL"
  | "NO"
  | "NP"
  | "NR"
  | "NU"
  | "NZ"
  | "OM"
  | "PA"
  | "PE"
  | "PF"
  | "PG"
  | "PH"
  | "PK"
  | "PL"
  | "PM"
  | "PN"
  | "PR"
  | "PS"
  | "PT"
  | "PW"
  | "PY"
  | "QA"
  | "RE"
  | "RO"
  | "RS"
  | "RW"
  | "SA"
  | "SB"
  | "SC"
  | "SD"
  | "SE"
  | "SG"
  | "SH"
  | "SI"
  | "SJ"
  | "SK"
  | "SL"
  | "SM"
  | "SN"
  | "SO"
  | "SR"
  | "SS"
  | "ST"
  | "SV"
  | "SX"
  | "SZ"
  | "TC"
  | "TD"
  | "TF"
  | "TG"
  | "TH"
  | "TJ"
  | "TK"
  | "TL"
  | "TM"
  | "TN"
  | "TO"
  | "TR"
  | "TT"
  | "TV"
  | "TW"
  | "TZ"
  | "UA"
  | "UG"
  | "UK"
  | "UM"
  | "US"
  | "UY"
  | "UZ"
  | "VA"
  | "VC"
  | "VG"
  | "VI"
  | "VN"
  | "VU"
  | "WF"
  | "WS"
  | "XK"
  | "YE"
  | "YT"
  | "ZA"
  | "ZM"
  | "ZW";

export type TCountry = Record<TCountryCode, Readonly<TCountryData>>;

const COUNTRIES: Readonly<TCountry> = {
  AA: { name: "aa", flag: AA }, // only for AA, use HealthAuthority.constants.ts for custom flags/orgs
  AD: { name: "ad", flag: AD },
  AE: { name: "ae", flag: AE },
  AF: { name: "af", flag: AF },
  AG: { name: "ag", flag: AG },
  AI: { name: "ai", flag: AI },
  AL: { name: "al", flag: AL },
  AM: { name: "am", flag: AM },
  AO: { name: "ao", flag: AO },
  AQ: { name: "aq", flag: AQ },
  AR: { name: "ar", flag: AR },
  AS: { name: "as", flag: AS },
  AT: { name: "at", flag: AT },
  AU: { name: "au", flag: AU },
  AW: { name: "aw", flag: AW },
  AX: { name: "ax", flag: AX },
  AZ: { name: "az", flag: AZ },
  BA: { name: "ba", flag: BA },
  BB: { name: "bb", flag: BB },
  BD: { name: "bd", flag: BD },
  BE: { name: "be", flag: BE },
  BF: { name: "bf", flag: BF },
  BG: { name: "bg", flag: BG },
  BH: { name: "bh", flag: BH },
  BI: { name: "bi", flag: BI },
  BJ: { name: "bj", flag: BJ },
  BL: { name: "bl", flag: BL },
  BM: { name: "bm", flag: BM },
  BN: { name: "bn", flag: BN },
  BO: { name: "bo", flag: BO },
  BQ_BO: { name: "bq-bo", flag: BQ_BO },
  BQ_SA: { name: "bq-sa", flag: BQ_SA },
  BQ_SE: { name: "bo-se", flag: BQ_SE },
  BR: { name: "br", flag: BR },
  BS: { name: "bs", flag: BS },
  BT: { name: "bt", flag: BT },
  BV: { name: "bv", flag: BV },
  BW: { name: "bw", flag: BW },
  BZ: { name: "bz", flag: BZ },
  CA: { name: "ca", flag: CA },
  CC: { name: "cc", flag: CC },
  CD: { name: "cd", flag: CD },
  CF: { name: "cf", flag: CF },
  CG: { name: "cg", flag: CG },
  CH: { name: "ch", flag: CH },
  CI: { name: "ci", flag: CI },
  CK: { name: "ck", flag: CK },
  CL: { name: "cl", flag: CL },
  CM: { name: "cm", flag: CM },
  CO: { name: "co", flag: CO },
  CR: { name: "cr", flag: CR },
  CV: { name: "cv", flag: CV },
  CW: { name: "cw", flag: CW },
  CX: { name: "cx", flag: CX },
  CY: { name: "cy", flag: CY },
  CZ: { name: "cz", flag: CZ },
  DE: { name: "de", flag: DE },
  DJ: { name: "dj", flag: DJ },
  DK: { name: "dk", flag: DK },
  DM: { name: "dm", flag: DM },
  DO: { name: "do", flag: DO },
  DZ: { name: "dz", flag: DZ },
  EC: { name: "ec", flag: EC },
  EE: { name: "ee", flag: EE },
  EG: { name: "eg", flag: EG },
  EH: { name: "eh", flag: EH },
  ER: { name: "er", flag: ER },
  ES: { name: "es", flag: ES },
  ET: { name: "et", flag: ET },
  EU: { name: "eu", flag: EU },
  FI: { name: "fi", flag: FI },
  FJ: { name: "fj", flag: FJ },
  FK: { name: "fk", flag: FK },
  FM: { name: "fm", flag: FM },
  FO: { name: "fo", flag: FO },
  FR: { name: "fr", flag: FR },
  GA: { name: "ga", flag: GA },
  GB: { name: "gb", flag: UK },
  GD: { name: "gd", flag: GD },
  GE: { name: "ge", flag: GE },
  GF: { name: "gf", flag: GF },
  GG: { name: "gg", flag: GG },
  GH: { name: "gh", flag: GH },
  GI: { name: "gi", flag: GI },
  GL: { name: "gl", flag: GL },
  GM: { name: "gm", flag: GM },
  GN: { name: "gn", flag: GN },
  GP: { name: "gp", flag: GP },
  GQ: { name: "gq", flag: GQ },
  GR: { name: "gr", flag: GR },
  GS: { name: "gs", flag: GS },
  GT: { name: "gt", flag: GT },
  GU: { name: "gu", flag: GU },
  GW: { name: "gw", flag: GW },
  GY: { name: "gy", flag: GY },
  HK: { name: "hk", flag: HK },
  HM: { name: "hm", flag: HM },
  HN: { name: "hn", flag: HN },
  HR: { name: "hr", flag: HR },
  HT: { name: "ht", flag: HT },
  HU: { name: "hu", flag: HU },
  ID: { name: "id", flag: ID },
  IE: { name: "ie", flag: IE },
  IL: { name: "il", flag: IL },
  IM: { name: "im", flag: IM },
  IN: { name: "in", flag: IN },
  IO: { name: "io", flag: IO },
  IQ: { name: "iq", flag: IQ },
  IS: { name: "is", flag: IS },
  IT: { name: "it", flag: IT },
  JE: { name: "je", flag: JE },
  JM: { name: "jm", flag: JM },
  JO: { name: "jo", flag: JO },
  JP: { name: "jp", flag: JP },
  KE: { name: "ke", flag: KE },
  KG: { name: "kg", flag: KG },
  KH: { name: "kh", flag: KH },
  KI: { name: "ki", flag: KI },
  KM: { name: "km", flag: KM },
  KN: { name: "kn", flag: KN },
  KR: { name: "kr", flag: KR },
  KW: { name: "kw", flag: KW },
  KY: { name: "ky", flag: KY },
  KZ: { name: "kz", flag: KZ },
  LA: { name: "la", flag: LA },
  LB: { name: "lb", flag: LB },
  LC: { name: "lc", flag: LC },
  LI: { name: "li", flag: LI },
  LK: { name: "lk", flag: LK },
  LR: { name: "lr", flag: LR },
  LS: { name: "ls", flag: LS },
  LT: { name: "lt", flag: LT },
  LU: { name: "lu", flag: LU },
  LV: { name: "lv", flag: LV },
  LY: { name: "ly", flag: LY },
  MA: { name: "ma", flag: MA },
  MC: { name: "mc", flag: MC },
  MD: { name: "md", flag: MD },
  ME: { name: "me", flag: ME },
  MF: { name: "mf", flag: MF },
  MG: { name: "mg", flag: MG },
  MH: { name: "mh", flag: MH },
  MK: { name: "mk", flag: MK },
  ML: { name: "ml", flag: ML },
  MM: { name: "mm", flag: MM },
  MN: { name: "mn", flag: MN },
  MO: { name: "mo", flag: MO },
  MP: { name: "mp", flag: MP },
  MQ: { name: "mq", flag: MQ },
  MR: { name: "mr", flag: MR },
  MS: { name: "ms", flag: MS },
  MT: { name: "mt", flag: MT },
  MU: { name: "mu", flag: MU },
  MV: { name: "mv", flag: MV },
  MW: { name: "mw", flag: MW },
  MX: { name: "mx", flag: MX },
  MY: { name: "my", flag: MY },
  MZ: { name: "mz", flag: MZ },
  NA: { name: "na", flag: NA },
  NC: { name: "nc", flag: NC },
  NE: { name: "ne", flag: NE },
  NF: { name: "nf", flag: NF },
  NG: { name: "ng", flag: NG },
  NI: { name: "ni", flag: NI },
  NL: { name: "nl", flag: NL },
  NO: { name: "no", flag: NO },
  NP: { name: "np", flag: NP },
  NR: { name: "nr", flag: NR },
  NU: { name: "nu", flag: NU },
  NZ: { name: "nz", flag: NZ },
  OM: { name: "om", flag: OM },
  PA: { name: "pa", flag: PA },
  PE: { name: "pe", flag: PE },
  PF: { name: "pf", flag: PF },
  PG: { name: "pg", flag: PG },
  PH: { name: "ph", flag: PH },
  PK: { name: "pk", flag: PK },
  PL: { name: "pl", flag: PL },
  PM: { name: "pm", flag: PM },
  PN: { name: "pn", flag: PN },
  PR: { name: "pr", flag: PR },
  PS: { name: "ps", flag: PS },
  PT: { name: "pt", flag: PT },
  PW: { name: "pw", flag: PW },
  PY: { name: "py", flag: PY },
  QA: { name: "qa", flag: QA },
  RE: { name: "re", flag: RE },
  RO: { name: "ro", flag: RO },
  RS: { name: "rs", flag: RS },
  RW: { name: "rw", flag: RW },
  SA: { name: "sa", flag: SA },
  SB: { name: "sb", flag: SB },
  SC: { name: "sc", flag: SC },
  SD: { name: "sd", flag: SD },
  SE: { name: "se", flag: SE },
  SG: { name: "sg", flag: SG },
  SH: { name: "sh", flag: SH },
  SI: { name: "si", flag: SI },
  SJ: { name: "sj", flag: SJ },
  SK: { name: "sk", flag: SK },
  SL: { name: "sl", flag: SL },
  SM: { name: "sm", flag: SM },
  SN: { name: "sn", flag: SN },
  SO: { name: "so", flag: SO },
  SR: { name: "sr", flag: SR },
  SS: { name: "ss", flag: SS },
  ST: { name: "st", flag: ST },
  SV: { name: "sv", flag: SV },
  SX: { name: "sx", flag: SX },
  SZ: { name: "sz", flag: SZ },
  TC: { name: "tc", flag: TC },
  TD: { name: "td", flag: TD },
  TF: { name: "tf", flag: TF },
  TG: { name: "tg", flag: TG },
  TH: { name: "th", flag: TH },
  TJ: { name: "tj", flag: TJ },
  TK: { name: "tk", flag: TK },
  TL: { name: "tl", flag: TL },
  TM: { name: "tm", flag: TM },
  TN: { name: "tn", flag: TN },
  TO: { name: "to", flag: TO },
  TR: { name: "tr", flag: TR },
  TT: { name: "tt", flag: TT },
  TV: { name: "tv", flag: TV },
  TW: { name: "tw", flag: TW },
  TZ: { name: "tz", flag: TZ },
  UA: { name: "ua", flag: UA },
  UG: { name: "ug", flag: UG },
  UK: { name: "uk", flag: UK },
  UM: { name: "um", flag: UM },
  US: { name: "us", flag: US },
  UY: { name: "uy", flag: UY },
  UZ: { name: "uz", flag: UZ },
  VA: { name: "va", flag: VA },
  VC: { name: "vc", flag: VC },
  VG: { name: "vg", flag: VG },
  VI: { name: "vi", flag: VI },
  VN: { name: "vn", flag: VN },
  VU: { name: "vu", flag: VU },
  WF: { name: "wf", flag: WF },
  WS: { name: "ws", flag: WS },
  XK: { name: "xk", flag: XK },
  YE: { name: "ye", flag: YE },
  YT: { name: "yt", flag: YT },
  ZA: { name: "za", flag: ZA },
  ZM: { name: "zm", flag: ZM },
  ZW: { name: "zw", flag: ZW },
};

export default COUNTRIES;
